/*
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
import * as M from "./materialize.cjs"
import * as Helpers from "./helpers"
import { Dictionary, IntegerDictionary, LANGUAGE_NAMES, LanguageCode, PNCTypes } from "./TypesAndEnums";
import { DatabaseAPI } from "./api";
import * as Run from "./run"
import * as Render from "./renderCutscene"
import { PNCxLuaReader, XLuaUtilities } from "./PNCxLuaReader";

//Replaced during webpack compile (See webpack.config.js)
//Default is "scripts/"
declare var __JS_SCRIPTS_PATH: string;
declare var __IS_QUART_SERVER: boolean;


//
// CONSTANTS AND SETUP
// Setup functions are probably in helpers.js
//
const CACHE_KEY = "pncApiResponseCache";


export namespace Globals {

	export const DefaultPlayerName = "Shikikan"

	export let CurrentLanguage:LanguageCode = 'en/'
	export let CurrentEpisode:string = "";

	export const DATABASE = new DatabaseAPI(CACHE_KEY); //Put this somewhere idfk
	//export const fgEffects = <HTMLTemplateElement>document.getElementById("fgEffects");
	//These are treated as global singleton objects, so they are capitalized.
	export let SETTINGS:Dictionary<any> = {};
	export let DICTIONARY:IntegerDictionary<PNCTypes.NounData> = {}
	export let LOCALE_TEXT:IntegerDictionary<string>;
	export let MODEL_CFG:IntegerDictionary<object>;
	export let COMM_CFG;
	export let TRUSTY_PATCHES:Dictionary<IntegerDictionary<any>> = {};
}

var curEpKey;
var currentEpisode;



//
//
//
	
/**
 * Loads a new story scene. Returns a promise that resolves to true or false depending on success/failure.
 * @param {number} keyString The scene you want to load
 * @returns {Promise<boolean>}
 */
export async function runFromRoutableKeyString(keyString:string, jumpTo:HTMLElement = null)
{
	if (!keyString || keyString.length === 0) {
		console.log("Tried to run from an empty key string.");
		return false;
	}

	if(keyString == "404") {
		return false;
	}

	//runFromRoutableKeyString is already async so this 
	// will return a promise that resolves to
	// returning true or false
	return Globals.DATABASE.getEpisode(keyString).then((ep) => {
		curEpKey = keyString;
		Run.run(ep, jumpTo); //This can throw an exception so why are we returning true???
		return true;
	})
}


export function goToPrevEpisode()
{
	if (Globals.CurrentEpisode) {
		let prev = Globals.DATABASE.getPrevEpisode(Globals.CurrentEpisode);
		//TODO: This is pretty stupid
		if (prev) {
			const newEpisodeLink = `${window.location.pathname}?permalink=${prev}`
			history.pushState(null, '', newEpisodeLink); // Rewrite URL

			runFromRoutableKeyString(
				prev,
				document.getElementById("chapterName")
			)
		}
	} else {
		console.log("Tried going to prev episode, but there isn't an episode set?")
	}
}

export function goToNextEpisode()
{
	if (Globals.CurrentEpisode) {
		let next = Globals.DATABASE.getNextEpisode(Globals.CurrentEpisode);
		if (next) {
			const newEpisodeLink = `${window.location.pathname}?permalink=${next}`
			history.pushState(null, '', newEpisodeLink); // Rewrite URL


			runFromRoutableKeyString(
				next,
				document.getElementById("chapterName")
			)
		}
	} else {
		console.log("Tried going to next episode, but there isn't an episode set?")
	}
}


async function generateNavButtons() {
	const mainContainer = document.getElementById("mainEpisodes");
	const eventContainer = document.getElementById("eventEpisodes");
	const sideContainer = document.getElementById("sideEpisodes");

	//What the fuck are we even doing here man
	Helpers.createDropDownBox("main", mainContainer, Globals.DATABASE.database.story.main as PNCTypes.Chapter[]);
	Helpers.createDropDownBox("event", eventContainer, Globals.DATABASE.database.story.event as PNCTypes.Chapter[]);
	Helpers.createDropDownBox("side", sideContainer, Globals.DATABASE.database.story.side as PNCTypes.Chapter[]);
}

namespace UserFile {

	//HANDLE FILE INPUT FOR CUSTOM CUTSCENE...
	export function dragOverHandler(ev:DragEvent) {
		ev.preventDefault();
	}

	export function dropHandler(ev:DragEvent) {
		console.log(ev);
		console.log('File(s) dropped');

		// Prevent default behavior (Prevent file from being opened)
		ev.preventDefault();

		processFiles([...ev.dataTransfer.files]);
	}

	export function handleFileSelect(evt:Event) {
		console.log((evt.target as HTMLInputElement).name);
		var files = (evt.target as HTMLInputElement).files;
		processFiles([...files]);
	}

	//type FileMeta = { file:File, name:string }

	export async function processFiles(files:File[]) {

		//let AvgConfig;
		//let AvgLang;
		try {
			var o:{AvgConfig:IntegerDictionary<any>, AvgLang:IntegerDictionary<string>} = {
				'AvgConfig':null,
				'AvgLang':null
			};
			for (let i = 0, f:File; f = files[i]; i++) {
				
				let k = "AvgConfig";
				if (f.name.includes("AvgLang"))
					k = "AvgLang";


				if (f.name.includes(".json")) {
					o[k] = JSON.parse(await f.text());
				} else {

					let content = await f.arrayBuffer();
					let buffer = new Uint8Array(content);

					if (XLuaUtilities.checkLuacHeader(buffer)) {
						//We know for sure this is lua bytecode
						let luac = XLuaUtilities.patchIfNecessary(buffer);
						o[k] = new PNCxLuaReader(luac).readFile();
					} else {
						throw Error("Reading lua is not implemented yet. luac only for now.")
					}
				}
			}

			if (!o['AvgConfig']) {
			//	console.log(o)
				throw new TypeError("missing AvgCfg file");
			}
			if (!o['AvgLang']) {
			//	console.log(o)
				throw new TypeError("Missing AvgLang")
			}

			console.log("AvgConfig and AvgLang loaded, let's roll!")
			console.log(o)
			let newSimpleTextDiv = document.createElement('div');
			newSimpleTextDiv.id="verySimpleText";
			newSimpleTextDiv.appendChild(await Render.renderPNCStructToDiv(o.AvgConfig, o.AvgLang));
			
			const oldSimpleTextDiv = document.getElementById("verySimpleText");
			oldSimpleTextDiv.parentNode.replaceChild(newSimpleTextDiv, oldSimpleTextDiv);
			Run.doToolTips(newSimpleTextDiv);

		} catch (e) {
			console.log(e);
			document.getElementById("customCutsceneError")?.setAttribute("style","color:red;display:block;");
			document.getElementById("customCutsceneError").innerText=e.message;
		}
	}

	//function resolveLuaOrJson(f)

	export function processUserFile(f:File) {
		var reader = new FileReader();
		reader.onload = function(e) {
			
			let NewSimpleTextDiv = document.createElement('div');
			NewSimpleTextDiv.id="verySimpleText";
			
			//var content = e.target.result;
			//console.log(e.target);
			console.log("Got user file")
			try {

				// let out = content;
				// let structuredLines = convertGFLTextToOpcodes(out);
				// currentEpisodeAsOpcodes = [structuredLines];
				// curEpKey = "";
				// let simpleTextDiv = document.getElementById("verySimpleText");
				// let NewSimpleTextDiv = document.createElement('div');
				// NewSimpleTextDiv.id="verySimpleText";
				// NewSimpleTextDiv.appendChild(renderStructuredLinesToDiv(structuredLines,0))
				
				// simpleTextDiv.parentNode.replaceChild(NewSimpleTextDiv,simpleTextDiv);
				// chapterName.innerText=f.name;
			}
			catch (e)
			{
				console.log(e);
				document.getElementById("customCutsceneError")?.setAttribute("style","color:red;display:block;");
				document.getElementById("customCutsceneError").innerText=e.message;
			}
		};
		//console.log(f);
		reader.readAsText(f)
	}
}

//
// Window onload logic, very important (maybe)
// Keep this at the bottom
// TODO: How the fuck do I make it so this only executes if it's in index.html???
//
window.onload=async function()
{
	new LoadingScreen().FromAsyncFunction(async (_: any) => {

		/* Load cache first */
		const ckey = "PNC_DB_VER";
		const dbVer = await Globals.DATABASE.getDatabaseVersion();

		Globals.SETTINGS = Helpers.initSettingsManager();
		//Language
		let tmp_lang = Helpers.getCookie('language');
		if (Object.values(LANGUAGE_NAMES).indexOf(tmp_lang) < 0)
			tmp_lang = "en/"
		//@ts-ignore
		Globals.CurrentLanguage = tmp_lang;

		let dd = document.getElementById("languageDropdown");
		for (let ln in LANGUAGE_NAMES)
		{
			/* I don't really like doing it this way but I'm short on patience. */
			dd.innerHTML += `<li>
			<a class="dropdown-item" href="javascript:void(0)"
				data-lang="${LANGUAGE_NAMES[ln]}">${ln}</a>
			</li>`;
		}
		/* Attach click handler. */
		dd.addEventListener('click', (e) => {
			const item = <HTMLAnchorElement>(e.target as HTMLLIElement).closest('a.dropdown-item');
			if (!item) return;
			e.preventDefault();                     // belt-and-suspenders
			const lang = item.getAttribute("data-lang")
			console.log("Setting language to "+lang)
			Helpers.SetLanguage(lang as LanguageCode).then(_ => {
				runFromHash();
			})
		});

		//This only has an effect if the browser is set to dark mode
		Helpers.NightMode(Globals.SETTINGS.darkTheme);
		
		//Await the two inner promises to finish
		await Promise.all([
			//Load the necessary language files
			Helpers.SetLanguage(Globals.CurrentLanguage).catch(async error => {
				console.error("Failed to load langauge files for "+Globals.CurrentLanguage+"... Something has gone horribly wrong");
				await Helpers.SetLanguage("en/")
			}),
			fetch(__JS_SCRIPTS_PATH+"patch.json")
			.then(resp => resp.json())
			.then(file => {
				Globals.TRUSTY_PATCHES = file;
			})

			// //Load the patch files
			// Promise.all(
			// 	[
			// 		"commCfg.json",
			// 		"patch.json"
			// 	].map(f => fetch(f).then(resp => resp.json()))
			// ).then((files) => {

			// 	//COMM_CFG = files[0];
			// 	Globals.TRUSTY_PATCHES = files[1];
			// }).catch(e => {
			// 	//console.log(e);
			// 	console.error("Ignoring missing file ",e)
			// })
		])
		console.log("Core static data fetched.");


		//debugger;
		await generateNavButtons();
		//Because webpack is not scoped globally...
		window["Globals"] = Globals;
		window["goToPrevEpisode"] = goToPrevEpisode;
		window["goToNextEpisode"] = goToNextEpisode;
		window['runFromHash'] = runFromHash;
		window['runFromRoutableKeyString'] = runFromRoutableKeyString;
		window['validateUrlAndExec'] = validateUrlAndExec;
		window['playNewAudio'] = Helpers.playNewAudio;
		window['playSFX'] = Helpers.playSFX;
		window['toast'] = function ShowToast(o:object) {
			new M.Toast(o)
		};
		//We have succesfully reinvented reflection...
		//Jokes aside this assigns all the functions in UserFile to global scope
		let funcs = Object.values(UserFile);
		for (let i = 0, val; val = funcs[i]; i++) {
			window[val.name] = val;
		}

		//window['M'] = M;
		document.getElementById("prevEpisodeButton").onclick = goToPrevEpisode;
		document.getElementById("nextEpisodeButton").onclick = goToNextEpisode;

		document.querySelectorAll('.dropdown-trigger').forEach(elems => {
			//dumb navbar hack
			if (elems.getAttribute("data-target")=="languageDropdown")
				M.Dropdown.init(elems, {constrainWidth:false, container: document.body});
			else
				M.Dropdown.init(elems, {constrainWidth:false});
		});

		document.querySelectorAll('.tabs').forEach(el => {
			M.Tabs.init(el);
		});
			
		document.querySelectorAll('.collapsible').forEach(elems => {
			M.Collapsible.init(elems, null);
		});
		document.querySelectorAll('.sidenav').forEach(elems => {
			M.Sidenav.init(elems,null);
		});

		document.querySelectorAll('.modal').forEach(el => {
			M.Modal.init(el, null);
		});
		
		M.FormSelect.init(document.querySelectorAll('select'), null);
		
		(document.getElementById('file-input-txt') as HTMLInputElement)?.addEventListener('change', UserFile.handleFileSelect, false);

		(document.getElementById("antibot") as HTMLAnchorElement).href = atob("aHR0cHM6Ly9kZXYucy11bC5uZXQvQkxVRUFMaUNFL3BuYy1jdXRzY2VuZS1pbnRlcnByZXRlcg==");
		(document.getElementById("player_name") as HTMLInputElement).setAttribute("placeholder", Globals.DefaultPlayerName);

		
	}).then(_ => {
		runFromHash(); //Await the previous loading screen to finish
	})
	
};
//
//
//

// window.onhashchange = function() {
// 	validateUrlAndExec().chain(url => runFromRoutableKeyString(url, document.getElementById("chapterName")));
// };

//There's no need to validate the URL since popstate would only ever have valid permalinks
window.onpopstate = function() {
	runFromHash();
}


/* Validates the current url and either returns what it thinks is the episode number
   or the name of the chapter element for dropdown manipulation. */
function validateUrl() {
	let url = window.location.hash.slice(1);
	if (Globals.DATABASE.hasEpisode(url))
		return url;
}


// type Fn = (x: any) => any;

// const createChain = (fns: Fn[] = []) => ({
//     chain(fn: Fn) {
//         return createChain([...fns, fn]);
//     },
//     run(initial: any) {
//         return fns.reduce((acc, fn) => fn(acc), initial);
//     }
// });

/**
 * Validates the URL then returns an object with a function named 'chain' which takes a function as an input.
 * 'chain' will execute the function inside it only if the url is valid. The url is then passed as the first argument to the function.
 * To use this with a custom defined function, you can do an anonymous function such as `validateUrlAndExec().chain(url => {console.log("The url",url," is valid.")})`;
 * @returns {object}
 */
function validateUrlAndExec(): {chain:Function} {

	//let url = decodeURI(window.location.hash.slice(1));
	const url = new URLSearchParams(window.location.search).get("permalink");
	if (Globals.DATABASE.hasEpisode(url))
		return {
			chain: function(f:Function) {
				return f(url)
			}
		}
	console.log("Database doesn't have an episode named "+url+", ignoring.");
	
	return {
		chain: function(f:any) {
			//return null;
		}
	}
}

function runFromHash(jumpTo:HTMLElement = null) {
	let url;
	if (__IS_QUART_SERVER)
		url = new URLSearchParams(window.location.search).get("permalink");
	else
		url = decodeURI(window.location.hash.slice(1));
	if (Globals.DATABASE.hasEpisode(url)) {
		runFromRoutableKeyString(url, jumpTo)
		return true;
	}
	return false;
}

/* A silly workaround to not wanting to use getElement twice, returns a scope with both functions. */
export class LoadingScreen {
	//TODO: Why is this a class in the first place... 99% of this shit can be made static -AMW

	/* Sure ok let's just hide the whole ass site why not. */
	private contentDiv = document.getElementById("verySimpleText");
	private footBtns = document.getElementById('storyFooterButtons');
	private audioPlr = document.getElementById('audioPlayer');
	private hr = document.querySelectorAll('hr');
	private footer = document.querySelector('footer');
	private static chName = document.getElementById('chapterName');
	private chDesc = document.getElementById('chapterDesc');

	private loadingBarWrapper = document.getElementById("loadingBar");
	private loadingbar = this.loadingBarWrapper.getElementsByClassName("progress")[0].firstElementChild;
	private loadingText = this.loadingBarWrapper.getElementsByTagName("p")[0]
	private limit = 0;

	//There's no way to specify that we need to pass in an async function here
	//But we do, since generatorFunction() would return a promise and we are 
	//doing .then() on that promise
	// constructor(generatorFunction:Function)
	// {
	// 	this.startLoading();
	// 	generatorFunction().then(_ => {
	// 		this.finishLoading();
	// 	})
	// }

	constructor(limit:number = 0) {
		if (limit != 0) {
			this.limit = limit;
			this.loadingbar.classList.replace("indeterminate","determinate");
			this.loadingbar.setAttribute("style","width:0%");
			this.loadingText.innerText = `Now Loading... (0/${this.limit})`
		} else {
			this.loadingbar.classList.replace("determinate","indeterminate");
			this.loadingbar.setAttribute("style","width:66.66666667%");
			this.loadingText.innerText = "Now Loading..."
		}
		if (Globals.SETTINGS.enableLoadingScreen)
			this.startLoading();
	}

	public async FromAsyncFunction(asyncFunction:Function) {
		return asyncFunction().then(_ => {
			this.finishLoading()
		});
	}

	// This is stupid. Why did I write this -AMW
	// public async FromGeneratorFunction(generatorFunction:AsyncGeneratorFunction, limit:number=0) {

	// 	const generator = generatorFunction();
	// 	while (true) {
	// 		const ret = await generator.next();
	// 		if (ret.done)
	// 			break;
	// 	}
	// 	this.finishLoading();
	// }

	public setProgress(progress:number=0) {
		this.loadingbar.setAttribute('style',"width:"+(progress)/this.limit*100+"%")
		this.loadingText.innerText = `Now Loading... (${progress}/${this.limit})`

		if (progress == this.limit) {
			this.finishLoading();
		}
	}

	private startLoading(newName:string = null, newDesc:string = null) {
		//console.log("Loading screen!!")
		this.loadingBarWrapper.setAttribute("style",""); 
		document.body.style.overflow = 'hidden'; /* Lock scroll bar. */


		/* Hide elements while being manipulated so the user doesn't see them. */
		// this.contentDiv.setAttribute("style","display:none");
		// this.chName.setAttribute("style","display:none");
		// this.chDesc.setAttribute("style","display:none");
		// this.footBtns.setAttribute("style","display:none");
		// this.audioPlr.setAttribute("style","display:none");
		// this.footer.style.display = 'none';
		// this.hr.forEach(h => h.style.display = 'none');

		//This has nothing to do with loading??? Why is it here
		// if(newName) { chName.innerText = newName; }
		// chDesc.innerHTML = newDesc ? newDesc : "";
	}
	
	private finishLoading() {
		/* Flip visibility back. */
		// chName.setAttribute("style","");
		// if(chDesc.innerHTML !== "") chDesc.setAttribute("style", "");
		this.loadingBarWrapper.setAttribute("style","display:none");
		// footBtns.setAttribute("style","");
		// audioPlr.setAttribute("style","");
		// footer.style.display = 'block';
		// hr.forEach(h => h.style.display = 'block');
		document.body.style.overflow = 'auto';

		//console.log("End loading screen!!")
	}

	public static scrollToTop(instant = false) {
		this.chName.scrollIntoView({ behavior: (instant ? 'instant' : 'smooth'), block: 'start' });
	}
}